<template>
  <div>
    <!-- Titulo -->
    <p>
      Datos de la zona geográfica
      <span
        id="boton_edit"
        title="Editar ubicación"
        @click="enableLocationForm()"
        v-if="isUserAdmin()"
      >
       <i class="far fa-edit"></i> Editar Ubicación
      </span>
    </p>

    <!-- Parametros a editar -->
    <div class="groupBox">
      <div v-if="isEnabledLocationForm">
        <b-row>
          <b-col>
            <form-input
              v-model="location.alias"
              label="Alias de zona"
              v-bind:required="true"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>
          <b-col>
            <b-form-group
              label="Tipología"
              label-class="font-weight-bold"
              class="form-location-label"
            >
              <b-form-select size="sm" v-model="selectedLocationType">
                <b-form-select-option value="null">
                  Seleccionar una...
                </b-form-select-option>

                <b-form-select-option
                  v-for="(locationTypeItem, index) in locationTypeList"
                  v-bind:key="index"
                  v-bind:value="locationTypeItem"
                >
                  {{ locationTypeItem.name }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <form-input
              v-model="location.location.province"
              label="Provincia"
              v-bind:required="true"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>
          <b-col>
            <form-input
              type="number"
              @keydown.native="zipCodeKeyDown($event)"
              v-model="location.location.zip"
              label="Código Postal"
              v-bind:required="true"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <form-input
              @keydown.native="coordinatesKeyDown($event)"
              v-model="location.location.latitude"
              label="Latitud"
              v-bind:disabled="false"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>
          <b-col>
            <form-input
              @keydown.native="coordinatesKeyDown($event)"
              v-model="location.location.longitude"
              label="Longitud"
              v-bind:disabled="false"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col> <small>* El campo debe ser rellenado</small><br /> </b-col>
        </b-row>
        <br />
        <b-row>
          <!--BOTON GUARDAR CAMBIOS -->
          <b-col>
            <b-form-group label-for="adduser">
              <b-button
                block
                type="submit"
                name="adduser"
                id="adduser"
                variant="primary"
                @click="updateLocation(location)"
              >
                <i class="fas fa-edit"></i>
                <span class="text-uppercase form-location-button"
                  >Guardar Cambios</span
                >
              </b-button>
            </b-form-group>
          </b-col>
          <!--BOTON SALIR DE LA EDICIÓN -->
          <b-col>
            <b-form-group label-for="cleanform">
              <b-button
                block
                type="reset"
                name="cleanform"
                id="cleanform"
                variant="warning"
                @click="disableLocationForm()"
              >
                <i class="fas fa-arrow-left"></i>
                <span class="text-uppercase form-location-button"
                  >Salir de la edicion</span
                >
              </b-button>
            </b-form-group>
          </b-col>
          <!--BOTON BORRRAR ZONA -->
          <b-col>
            <b-form-group label-for="deleteTab">
              <b-button
                block
                name="deleteTab"
                id="deleteTab"
                variant="danger"
                @click="deleteModalPopup(location._id)"
              >
                <i class="fas fa-trash-alt"></i>
                <span class="text-uppercase form-location-button"
                  >Borrar zona</span
                >
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div v-if="!isEnabledLocationForm">
        <b-row>
          <b-col cols="2">
            <b-form-group
              label="Alias de zona:"
              label-size="sm"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>

          <b-col>
            <span class="form-location-field-text">{{ location.alias }}</span>
          </b-col>

          <b-col cols="3">
            <b-form-group
              label="Tipología:"
              label-size="sm"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>

          <b-col>
            <span class="form-location-field-text">{{ ((location.type)?location.type.name:"Sin tipología") }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="2">
            <b-form-group
              label="Provincia:"
              label-size="sm"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>
          <b-col>
            <span class="form-location-field-text">{{
              location.location.province
            }}</span>
          </b-col>
          <b-col cols="3">
            <b-form-group
              label="Código Postal:"
              label-size="sm"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>
          <b-col>
            <span class="form-location-field-text">{{
              location.location.zip
            }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="2">
            <b-form-group
              label="Latitud:"
              label-size="sm"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>
          <b-col>
            <span class="form-location-field-text">{{
              location.location.latitude
            }}</span>
          </b-col>
          <b-col cols="3">
            <b-form-group
              label="Longitud:"
              label-size="sm"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>
          <b-col>
            <span class="form-location-field-text">{{
              location.location.longitude
            }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="2">
            <b-form-group
              label="Nodos:"
              label-size="sm"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>

          <b-col>
            <!-- INSERTAR NODOS AQUÍ -->
            <span class="form-location-field-text"
              >{{ nodeCount }} ({{ activeCount }} Act /
              {{ inactiveCount }} Inact)</span
            >
          </b-col>

          <b-col cols="3">
            <b-form-group
              label="Sensores:"
              label-size="sm"
              label-class="font-weight-bold"
              class="form-location-label"
            />
          </b-col>

          <b-col>
            <!-- INSERTAR SENSORES AQUÍ -->
            <span class="form-location-field-text">{{ sensorCount }}</span>
          </b-col>
        </b-row>
      </div>
    </div>
   
    <!-- Weather -->
    <!-- <b-row>
      <b-col>
        <Weather  v-if="!isEnabledLocationForm" :location="location" class="weather groupBox"/>
      </b-col>
    </b-row> -->




  </div>
</template>


<script>
import Spacer from "@/components/card/Spacer";
import Input from "@/components/common/form/Input";
import LocationService from "@/services/LocationService";
import UserService from "@/services/UserService";
// import Weather from "@/components/weather";


export default {
  name: "edit-location-device",
  props: ["location"],
  data() {
    return {
      selectedLocationType: {
        name: "",
        image: ""
      },
      isEnabledLocationForm: false,
      locationTypeList: [],
      nodeCount: 0,
      sensorCount: 0,
      activeCount: 0,
      inactiveCount: 0,
    };
  },
  components: {
    "spacer-card": Spacer,
    "form-input": Input,
    // Weather
  },  
  mounted() {
    //Cargamos la lista
    if (!this.location.type || this.location.type.name == "Tipología" ) {
      this.selectedLocationType = "null";
    } else {
      this.selectedLocationType = this.location.type;
    }
    this.retrieveLocationtypes();
    this.getNodeSensorCount();
  },
  methods: {
    //Método para solicitar el número de nodos y sensores
    getNodeSensorCount() {
      //Llamamos al servicio
      LocationService.nodeSensorCount(this.location._id)
        .then((response) => {
          this.nodeCount = response.data.numNodos;
          this.activeCount = response.data.numActivos;
          this.inactiveCount = response.data.numInactivos;
          this.sensorCount = response.data.numSensores;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    zipCodeKeyDown(event) {
      if (
        event.key != "Backspace" &&
        event.key != "Delete" &&
        event.key != "ArrowLeft" &&
        event.key != "ArrowRight" &&
        isNaN(Number(event.key))
      ) {
        event.preventDefault();
      }
    },
    coordinatesKeyDown(event) {
      if (
        event.key != "Backspace" &&
        event.key != "Delete" &&
        event.key != "ArrowLeft" &&
        event.key != "ArrowRight" &&
        event.key != "," &&
        event.key != "." &&
        event.key != "-" &&
        isNaN(Number(event.key))
      ) {
        event.preventDefault();
      }
    },
    deleteModalPopup(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Recuerde que una vez borrada la ubicación no podra ser recuperada de nuevo.",
          {
            title:
              "¿Estad usted seguro de borrar la ubicación seleccionada del sistema?",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Si, quiero borrarla",
            cancelTitle: "No, me he equivocado",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value == true) {
            this.deleteLocation(id);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },

    deleteLocation(id) {
      LocationService.delete(id)
        .then((response) => {
          let texto = "No existen elementos que desvincular";
          if (response.data.updatedChildren > 0) {
            texto =
              "Han quedado desvinculados " +
              response.data.updatedChildren +
              " nodo(s)";
          }
          this.$notify({
            group: "notificateDiv",
            type: "pepito",
            title: "Ubicación eliminada correctamente",
            text: texto,
            duration: 3000,
            speed: 1000,
          });
          this.$emit("locationdeleted", id);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async updateLocation(currentLocation) {
      if (this.selectedLocationType === "null") {
        currentLocation.type = null;  
      } else {
        currentLocation.type = this.selectedLocationType;
      }
      
      await LocationService.update(currentLocation)
        .then((response) => {
          this.disableLocationForm();
          //Mensaje de confirmacion
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: response.data.message
              ? response.data.message
              : "Ubicación actualizada",
            text: response.data.message
              ? ""
              : "¡La zona se ha actualizado con éxito!",
            duration: 3000,
            speed: 1000,
          });
          this.$emit("updated", currentLocation);
        })
        .catch((e) => {
          var errorText = e.response.data.error
            ? e.response.data.error
            : e.response.data.message;
          this.$notify({
            group: "notificateDiv",
            type: "error",
            title: "Error de servidor",
            text: errorText,
            duration: 3000,
            speed: 1000,
          });
        });
    },

    retrieveLocationtypes() {
      LocationService.getAllTypes()
        .then((response) => {
          this.locationTypeList = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    enableLocationForm() {
      this.isEnabledLocationForm = true;
    },

    disableLocationForm() {
      this.isEnabledLocationForm = false;
      this.$emit("editcancelled");
    },

    isUserAdmin() {
      return UserService.isUserAdmin();
    },
  },

};
</script>

<style scoped>

.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 15px 15px 0px 15px;
}

.form-location-label {
  color: #606266;
}

.form-location-field-text {
  margin-left: 20px;
  font-size: 0.85rem;
}

.form-location-button {
  font-size: 12px;
  font-weight: bold;
  margin-left: 5px;
}

#boton_edit {
  float: right;
  cursor: pointer; 
  margin-right: 20px;
  color: rgb(9, 43, 196);
  padding: 0px 10px;
  opacity: 0.6;
  border: solid;
  border-color: white;
  border-radius: 15px;
  background: white;
}
#boton_edit:hover {
  opacity: 1;
  background: rgb(176, 207, 243);
}

p {
 padding-left:10px;
}
</style>
  